// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"43":"test","235":"square","592":"collect"}[chunkId] || chunkId) + "." + {"43":"521a97aa","199":"c9c571fe","235":"e0f78b01","592":"4b1dff18"}[chunkId] + ".js";
};